<template>
    <div class="register">
        <BgManageTopbar :isRegister="true" />
        <div class="registerContent">
            <div class="logoDiv">
                <img src="@/assets/logo.png" @click="goHomeUrl()" alt="" class="logoImg">
            </div>
            <div class="registerFormDiv">
                <div class="registerForm">
                    <div class="registerFormContent">
                        <div class="registerFormTitle">用户注册</div>
                        <div class="tabsDiv">
                            <el-form label-position="top" label-width="80px" :model="formLabelAlign"
                                :rules="rules" ref="registerForm" class="registerFormByTab">

                                    <!-- 推荐单位 -->
                                    <el-form-item label="推荐单位/推荐个人" prop="user_recommend_id" >
                                        <el-select filterable clearable v-model="formLabelAlign.user_recommend_id" placeholder="请选择上级推荐单位/推荐个人" style="width: 100%;">
                                        <el-option :label="recommend.user_name" :value="recommend.id" v-for="recommend in recommendList"></el-option>
                                        </el-select>
                                    </el-form-item>

                                    <!-- 单位名称 -->
                                    <el-form-item label="单位名称" prop="org_name" >
                                        <el-input v-model="formLabelAlign.org_name" placeholder="请输入您所在的单位名称"></el-input>
                                    </el-form-item>

                                    <!-- 真实姓名 + 手机号 同一行 -->
                                    <div class="formRow">
                                        <el-form-item label="真实姓名" prop="name" class="halfItem">
                                            <el-input v-model="formLabelAlign.name" placeholder="请输入真实姓名"></el-input>
                                        </el-form-item>
                                        <el-form-item label="手机号" prop="mobile" class="halfItem">
                                            <el-input v-model="formLabelAlign.mobile" placeholder="请输入手机号"></el-input>
                                        </el-form-item>
                                    </div>

                                    <!-- 验证码 + 倒计时按钮 同一行 -->
                                    <div class="formRow verifyCodeRow">
                                        <el-form-item label="验证码" prop="code" class="verifyCodeInput">
                                            <el-input v-model="formLabelAlign.code" placeholder="请输入验证码"></el-input>
                                        </el-form-item>
                                        <el-button type="primary" @click="getVerifyCode" :disabled="countdown > 0" class="verifyCodeBtn">
                                            {{ countdown > 0 ? `${countdown}s后重发` : '获取验证码' }}
                                        </el-button>
                                    </div>

                                    <!-- 密码 + 确认密码 同一行 -->
                                    <div class="formRow">
                                        <el-form-item label="密码" prop="password" class="halfItem">
                                            <div class="pwdDiv">
                                                <el-input :type="pwdType" v-model="formLabelAlign.password" placeholder="请输入密码"></el-input>
                                                <img :src="pwdType == 'password' ? noPwdIcon : pwdIcon" class="pwdImg" alt="" @click="togglePwdType">
                                            </div>
                                        </el-form-item>
                                        <el-form-item label="确认密码" prop="password2" class="halfItem">
                                            <div class="pwdDiv">
                                                <el-input :type="confirmPwdType" v-model="formLabelAlign.password2" placeholder="请再次输入密码"></el-input>
                                                <img :src="confirmPwdType == 'password' ? noPwdIcon : pwdIcon" class="pwdImg" alt="" @click="toggleConfirmPwdType">
                                            </div>
                                        </el-form-item>
                                    </div>

                                    <!-- 注册按钮 -->
                                    <el-form-item>
                                        <el-button type="primary" @click="onSubmit" class="registerBtn">注册</el-button>
                                    </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
            <CommonFooter />
        </div>
    </div>
</template>

<script>
import BgManageTopbar from '../components/BgManageTopbar.vue'
import CommonFooter from '../components/CommonFooter.vue'
import noPwdIcon from '@/assets/noPwd.png'
import pwdIcon from '@/assets/pwd.png'

export default {
    name: 'Register',
    components: {
        BgManageTopbar,
        CommonFooter
    },
    data() {
        return {
            pwdType: 'password',
            confirmPwdType: 'password',
            tjdwSelectIndex:0,
            rememberPwd: false,
            countdown: 0,
            timer: null,
            formLabelAlign: {
                user_recommend_id: '',
                org_name: '',
                name: '',
                mobile: '',
                code: '',
                password: '',
                password2: '',
            },
            noPwdIcon,
            pwdIcon,
            recommendList:[],
            rules: {
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入登录密码', trigger: 'blur' }
                ],
                password2: [
                    { required: true, message: '请再次输入密码', trigger: 'blur' }
                ],
                user_recommend_id: [
                    { required: true, message: '请选择上级推荐单位/推荐个人', trigger: 'change' }
                ],
                org_name: [
                    { required: true, message: '请输入您所在的单位名称', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入真实姓名', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'blur' }
                ]
            }
        }
    },

    mounted() {
        this.getRecommendListData();
    },
    methods: {
                    goHomeUrl(){
      window.open("https://www.isefc.org/index.php/zh/", "_blank");
    },
        getRecommendListData(){
            this.$API.getLoginRecommendList({
                identify:'1,2',
            }).then(res => {
                this.recommendList = res.data;
            })
        },
        togglePwdType() {
            this.pwdType = this.pwdType === 'password' ? 'text' : 'password'
        },

        toggleConfirmPwdType() {
            this.confirmPwdType = this.confirmPwdType === 'password' ? 'text' : 'password'
        },

        // 获取验证码倒计时
        getVerifyCode() {
            if (!this.formLabelAlign.mobile) {
                this.$message.warning('请先输入手机号')
                return
            }
            if (!/^1[3-9]\d{9}$/.test(this.formLabelAlign.mobile)) {
                this.$message.warning('手机号格式不正确')
                return
            }
            this.$API.getSendSms({
                mobile:this.formLabelAlign.mobile,
                type:1
            }).then(res => {
            this.$message.success('验证码已发送')
            this.countdown = 60
            this.timer = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--
                } else {
                    clearInterval(this.timer)
                    this.timer = null
                }
            }, 1000)
        })



        },

        onSubmit() {
            this.$refs.registerForm.validate((valid) => {
                if (valid) {
                    this.$API.goRegister(this.formLabelAlign).then(res => {
                            this.$message.success('注册成功')
                            this.$router.push({ path: "/Login" })
                    })
                    // 这里写注册逻辑
                } else {
                    console.log('表单校验失败')
                    return false
                }
            })
        }
    }
}
</script>

<style scoped>
.registerBtn {
    width: 100%;
    margin-top: 15px;
}

::v-deep .el-button+.el-button {
    margin-left: 0 !important;
}

::v-deep .el-form-item {
    margin-bottom: 10px !important;
}

.registerFormTitle {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 20px;
    color: #393939;
    text-align: center;
}

.registerFormContent {
    padding: 20px;
}

.registerFormDiv {
    display: flex;
    justify-content: center;
}

.registerForm {
    width: 459px;
    background: #F7F8FC;
    box-shadow: 0px 0px 8px 1px rgba(112, 112, 112, 0.1);
    border-radius: 12px 12px 12px 12px;
}

.logoImg {
    width: 323px;
    height: 76px;
}

.register {
    width: 100%;
    min-height: 100vh;
    background: url('../../../assets/loginBg.png') no-repeat center center;
    background-size: 100% 100%;
}

.logoDiv {
    display: flex;
    justify-content: center;
    margin-top: 70px;
    margin-bottom: 20px;
}

.flexAliCenter{
    display: flex;
    align-items: center;
}

.pl10{
    padding-left: 20px;
}

/* 表单行布局 - 两个表单项同一行 */
.formRow {
    display: flex;
    justify-content: space-between;
}

.halfItem {
    width: 48%;
}

/* 验证码行特殊布局 */
.verifyCodeRow {
    display: flex;
    align-items: center;
}

.verifyCodeInput {
    flex: 1;
}

.verifyCodeBtn {
    width: 120px;
    height: 40px;
    flex-shrink: 0;
    margin-top: 30px;
}

::v-deep .el-form-item__label {
    padding: 0 !important;
}

::v-deep .el-tabs__item {
    font-size: 16px !important;
}

::v-deep .el-tabs__nav {
    padding-bottom: 6px;
}

.tabsDiv {
    margin-top: 20px;
}

/* 密码框样式 */
.pwdDiv {
    position: relative;
}

.pwdImg {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    width: 18px;
    height: 15px;
}
</style>
